/**
 * Paleta kategorialna wykresów — tokeny `chart/1–6` z systemu „Workflow 3.0" (Figma 08.6
 * „Cards & widgets": „Charts use chart/1–6 fills, chart/grid lines … never ad-hoc colours";
 * wartości z palety `01 · Colors`, grupa „Chart & accents"). Zastępuje dawną, ad-hoc listę
 * hexów w `CustomWidgetChart`.
 *
 * Figma trzyma osobne wartości dla trybu jasnego (L) i ciemnego (D); różnią się tylko
 * chart/1 (brand rozjaśniony), chart/6 (neutral), grid i track. Wybór wariantu robi
 * `useChartTheme()` (`lib/use-chart-theme.ts`).
 */
export const CHART_PALETTE = [
  '#2455db', // chart-1 — brand (niebieski)
  '#9c61ea', // chart-2 — violet
  '#0fa3a3', // chart-3 — teal
  '#f5660b', // chart-4 — orange
  '#c724b1', // chart-5 — magenta
  '#a9a9b7', // chart-6 — neutral
] as const;

/** Linie siatki wykresu — token `chart/grid`. */
export const CHART_GRID = '#e6e6ec';

/** Tor/tło serii (np. nieaktywna część słupka) — token `chart/track`. */
export const CHART_TRACK = '#f1f1f4';

/** Warianty trybu ciemnego (Figma: `D #…` przy tokenach chart/*). */
export const CHART_PALETTE_DARK = [
  '#6389f5', // chart-1
  '#9c61ea', // chart-2
  '#0fa3a3', // chart-3
  '#f5660b', // chart-4
  '#c724b1', // chart-5
  '#7b7b8b', // chart-6
] as const;

export const CHART_GRID_DARK = '#2e2e38';
export const CHART_TRACK_DARK = '#2e2e38';
